import { get, writable } from 'svelte/store';

import { planning, mainMenu } from '../../../stores/store';
import { api } from '../../../stores/api';
import { features } from '../../shared/Features/features';
import { NotificationSystemApi } from './NotificationSystemApi';
import { NotificationSystemQueries } from './NotificationSystemQueries';
import { NotificationSystemContext } from './NotificationSystemContext';
import { Job } from '../Jobs/Job';

export class NotificationSystemApp {
    context: NotificationSystemContext = new NotificationSystemContext();
    msq: NotificationSystemQueries = new NotificationSystemQueries();
    checkDataTimeIntervalSeconds = 60;
    intervalHandler: any;
    api: any = get(api);
    onCheckData: (context: NotificationSystemContext) => void;

    constructor() {
        this.onCheckData = () => {};
    }

    start(onCheckData: (context: NotificationSystemContext) => void) {
        this.onCheckData = onCheckData;
        this.checkData();
        this.intervalHandler = setTimeout(() => {
            this.checkData();
        }, this.checkDataTimeIntervalSeconds * 1000);
    }

    reload() {
        this.checkData();
    }

    stop() {
        if (this.intervalHandler) clearInterval(this.intervalHandler);
    }

    async getJobsData() {
        const data = await Promise.all([
            NotificationSystemApi.getAdhocNotRejectedJobsData(this.api, this.msq),
            NotificationSystemApi.getAdhocRejectedJobsData(this.api, this.msq),
            NotificationSystemApi.getRejectedJobsData(this.api, get(planning).selectedDay),
        ]);
        this.context = {
            ...this.context,
            jobAdHocNotRejected: data[0].map(r => new Job().set(r)),
            jobAdHocRejected: data[1].map(r => new Job().set(r)),
            jobRejected: data[2].map(r => new Job().set(r)),
        };
        return this.context;
    }

    checkData() {
        if (this.intervalHandler) clearInterval(this.intervalHandler);
        if (get(features).feature_ux_improvements) {
            let pagePlanning = get(mainMenu).items.find((i) => i.id == 'PagePlanning');
            if (pagePlanning?.notification) {
                pagePlanning.notification.reload = true;
                mainMenu.set(get(mainMenu));
            }
        }
        Promise.all([
            NotificationSystemApi.getAdHocNotRejectedJobsCount(this.api, this.msq),
            NotificationSystemApi.getAdhocRejectedJobsCount(this.api, this.msq),
            NotificationSystemApi.getRejectedJobsCount(this.api, get(planning).selectedDay),
            // NotificationSystemApi.getAdhocNotRejectedJobsData(this.api, this.msq),
            // NotificationSystemApi.getAdhocRejectedJobsData(this.api, this.msq),
        ])
            .then(data => {
                this.context = {
                    ...this.context,
                    jobAdHocNotRejectedQuery: data[0].count,
                    jobAdHocRejectedQuery: data[1].count,
                    jobRejectedQuery: data[2].count,
                    // jobAdHocNotRejected: data[2].map(r => new Job().set(r)),
                    // jobAdHocRejected: data[3].map(r => new Job().set(r)),
                };
                this.onCheckData(this.context);
                this.intervalHandler = setTimeout(() => {
                    this.checkData();
                }, this.checkDataTimeIntervalSeconds * 1000);
            })
            .catch(e => {
                console.error(e);
                this.intervalHandler = setTimeout(
                    () => {
                        this.checkData();
                    },
                    this.checkDataTimeIntervalSeconds * 1000 * 2
                );
            });
    }

    areThereAnyAdhocs() {
        return this.context.jobAdHocNotRejectedQuery > 0 || this.context.jobAdHocRejectedQuery > 0;
    }

    areThereAnyRejected(): boolean {
        return this.context.jobRejectedQuery > 0;
    }
}
